import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { JobStatus } from 'packages/lib/api/logminer/contract/log-miner-types';
import deepEqual from 'fast-deep-equal';

/** Stores the job status for a specific result item.
 * key is item's logname + timestamp (as a string)
 * Populated by result-item.tsx */
export const jobStatusAtomFamily = atomFamily(
  (_param: string) => atom<JobStatus | null>(null),
  deepEqual
);
